export var getUpOrDownFromBoolean = function getUpOrDownFromBoolean(willOpenAbove) {
  return willOpenAbove ? 'up' : 'down';
};